import {useEffect} from "react";

function useOnClickOutside(refs, handler) {
    useEffect(() => {
        const isSupport = !!document && !!document.addEventListener;
        const listener = event => {
            // Do nothing if clicking ref's element or descendent elements
            let reject = false;
            refs.forEach((ref) => {
                    if (!ref.current || ref.current.contains(event.target)) {
                        reject = true;
                    }
                }
            );
            if (!reject) {
                handler(event);
            }
        };

        isSupport && document.addEventListener('mousedown', listener, {passive: true});
        isSupport && document.addEventListener('touchstart', listener, {passive: true});

        return () => {
            isSupport && document.removeEventListener('mousedown', listener);
            isSupport && document.removeEventListener('touchstart', listener);
        };
    });
}

export default useOnClickOutside;
